import useMediaQueries from "../../../hooks/useMediaQueries.js";
import LanguagePicker from "../../Structure/Header/LanguagePicker.js";
import Image from "components/Elements/Image/Image.tsx";
import Button from "components/Elements/Button/Button.js";
import isCustomDomainPage from "../../../helpers/isCustomDomainPage.ts";
import useOrganization from "hooks/useOrganization.ts";
import InboxIncognitoModal, {
  STORAGE_INCOGNITO_INBOX_MODAL_KEY,
  WEEK_IN_MS,
} from "./InboxIncognitoModal/index.tsx";
import { useContent } from "../../../contexts/contentContext/contentContext.js";
import { useUser } from "../../../contexts/userContext/userContext.js";
import { useModal } from "../../../contexts/modalContext/modalContext.js";
import { getLocalStorage } from "utils/globalLocalStorage.js";
import Authentication from "../Authentication/index.tsx";

const MIN_WIDTH_TO_SHOW_INBOX = 1300;

export const UserLoggedOutSection = ({ isWhite }) => {
  const { desktopCondition } = useMediaQueries();
  const { getTextByKey } = useContent();
  const { getUserProfileImage } = useUser();
  const { setModal } = useModal();
  const { checkCurrDomainIsOrgDomain } = useOrganization();

  const isOrgDomain = checkCurrDomainIsOrgDomain();

  const setLogin = () => {
    setModal({
      modal: Authentication,
      modalSize: "full-modal",
      props: {
        type: "sign-in",
      },
    });
  };

  const setSignup = () =>
    setModal({
      modal: Authentication,
      modalSize: "full-modal",
      props: { type: "sign-up" },
    });

  const openInboxIncognitoModal = () => {
    setModal({ modal: InboxIncognitoModal, modalSize: "full-modal" });
  };

  const handleInbox = () => {
    const storageValue = getLocalStorage(STORAGE_INCOGNITO_INBOX_MODAL_KEY);

    if (storageValue) {
      const appearances = JSON.parse(storageValue) || [];
      const now = Date.now();

      // Count timestamps within the last week
      const count = appearances.filter(
        (timestamp) => now - +timestamp < WEEK_IN_MS
      ).length;

      // 6 cos fo some issue with rerendering, its counting twice
      // memo not an option, because it styles requires custom modalSize
      if (count >= 6) {
        setLogin();
        return;
      }
    }

    openInboxIncognitoModal();
  };

  return (
    <div className="login-signup-buttons">
      {desktopCondition ? (
        <>
          {window.innerWidth > MIN_WIDTH_TO_SHOW_INBOX &&
            !isCustomDomainPage() && (
              <Button className="inbox-incognito" onClick={handleInbox}>
                {getTextByKey("inbox")}
              </Button>
            )}
          <button className="sign-in-button" onClick={setLogin}>
            {getTextByKey("login")}
          </button>
          {isCustomDomainPage() || isOrgDomain ? null : (
            <button className="sign-up-button" onClick={setSignup}>
              {getTextByKey("signup")}
            </button>
          )}
          <LanguagePicker />
        </>
      ) : (
        <div className="login-avatar-icon">
          {getUserProfileImage() ? (
            <Image
              className={`user-avatar-image default-image ${
                isWhite ? "white-image" : ""
              }`}
              src={getUserProfileImage()}
              title=""
              alt=""
            />
          ) : (
            <>
              <button className="sign-in-button" onClick={setLogin}>
                {getTextByKey("login")}
              </button>
              {isCustomDomainPage() || isOrgDomain ? null : (
                <button className="sign-up-button" onClick={setSignup}>
                  {getTextByKey("signup")}
                </button>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};
